import styled from 'styled-components';
import BaseCircle from '../../components/BaseCircle';
import { colors } from '../../theme/helpers';

const MyVillagersButton = styled.button`
  display: flex;
  align-items: center;
  color: white;
  margin: 1rem;
  background-color: ${colors.primaryPeach};
  border-radius: 10px;
  p {
    margin-left: 0.75rem;
  }

  :hover {
    color: white;
    background-color: ${colors.primaryLightPeach};
    transition: 0.3s;
  }
`;

export const RemoveVillagers = styled.button`
  color: ${colors.primaryLightPeach};
  padding: 0.5rem;
  margin: 1rem;
  border-radius: 10px;
  border: 1px solid ${colors.primaryLightPeach};
  :hover {
    color: white;
    background-color: ${colors.primaryLightPeach};
    transition: 0.3s;
  }
`;
export const Circle = styled(BaseCircle)`
  height: 40px;
  width: 40px;
  border-radius: 50%;
  background: #fdf2f2;
  margin: 1rem;
`;

export default MyVillagersButton;
